import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/codebuild/output/src4098491044/src/nuxt/layouts/default.vue").then(m => m.default || m)),
  guest: defineAsyncComponent(() => import("/codebuild/output/src4098491044/src/nuxt/layouts/guest.vue").then(m => m.default || m))
}